import { render, staticRenderFns } from "./IconSunSet.vue?vue&type=template&id=0fef3088&"
import script from "./IconSunSet.vue?vue&type=script&lang=js&"
export * from "./IconSunSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports